import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class CaseStateCaseMode extends Resource {
    public override type = 'caseStateCaseModes';

    @prop()
    public caseStateId!: string;

    @prop()
    public caseModeId!: string;
}
